import { Purchase } from '@com-delta-idp/mnx-sky-club-ui';
import {
  AEMErrorMessage,
  checkErrors,
  getEmptyContent,
  isDisplay,
  isError,
  isValidData
} from '@com-delta-idp/mnx-skymiles-shared';
import { logError } from '@com-delta-idp/mnx-utils';
import {
  AEMPurchaseContent,
  MembershipDetailMap,
  NewMembershipOptions,
  Options,
  SKY_CLUB_ERROR
} from '../models';
import { createOptionForMembershipType } from './purchase.adapter-helper';

export const getPurchase = (
  aem: AEMPurchaseContent | undefined,
  membership: MembershipDetailMap | undefined,
  aemErrorMessages: AEMErrorMessage[] | undefined,
  errors: (string | undefined)[],
  featureFlag: boolean | undefined,
  medallionMemberDesc?: string,
  membershipLevel?: string
): Purchase => {
  try {
    if (checkErrors(errors, aemErrorMessages)) {
      return isError<Purchase>(
        errors.find((error) => error != undefined) as string,
        aemErrorMessages as AEMErrorMessage[],
        featureFlag
      );
    }
    return isValidData<
      AEMPurchaseContent,
      [AEMPurchaseContent | undefined, boolean | undefined]
    >('total', aem, featureFlag)
      ? adaptPurchase(
          aem as AEMPurchaseContent,
          membership,
          featureFlag as boolean,
          medallionMemberDesc,
          membershipLevel
        )
      : isDisplay<Purchase>(featureFlag);
  } catch (error) {
    logError(
      error as Error,
      'DIGITAL_CUSTOMER_LOYALTY',
      'SKY_CLUB',
      'PURCHASE'
    );
    return getEmptyContent<Purchase>(
      SKY_CLUB_ERROR,
      aemErrorMessages,
      true,
      true
    );
  }
};

export const adaptPurchase = (
  aem: AEMPurchaseContent,
  membership: MembershipDetailMap | undefined,
  featureFlag: boolean,
  medallionMemberDesc?: string,
  membershipLevel?: string
): Purchase => {
  return featureFlag
    ? {
        options: getOptionsData(aem.options, membership),
        action: aem.action,
        total: aem.total,
        disabled: !featureFlag,
        isMembership: !!membership,
        loaded: true,
        medallionMemberDesc: medallionMemberDesc,
        membershipLevel: membershipLevel
      }
    : getEmptyContent<Purchase>('', [], true, true);
};

export const getOptionsData = (
  aemContent: Options[],
  membershipDetail: MembershipDetailMap | undefined
): Options[] => {
  let membershipOptions: Options[] = [];
  let newOrRenewalmembershipOptions: NewMembershipOptions = {};
  if (membershipDetail) {
    newOrRenewalmembershipOptions =
      membershipDetail['NEW MEMBERSHIP OPTIONS'] ||
      membershipDetail['MEMBERSHIP RENEWAL OPTIONS'] ||
      {};
    membershipOptions = processMembershipOptions(
      aemContent,
      newOrRenewalmembershipOptions
    );
  }
  return membershipOptions;
};

export const processMembershipOptions = (
  aemContent: Options[],
  membershipTypeOptions: NewMembershipOptions
): Options[] => {
  return Object.keys(membershipTypeOptions).map((key) =>
    createOptionForMembershipType(key, membershipTypeOptions, aemContent)
  );
};
